import { useNavigate } from "react-router-dom";
import { HomeIcon, Menu } from "@forge/common";
import "./left-panel.scss";
import { btnResponsive, textResponsive } from "../../utils/helper";
import useAuth from "../../../../../../common/hooks/useAuth";
import { PermissionConstant } from "../../utils/permission";
import { LIBRARY_ROUTES } from "../../../create-course/utils/constants";

const LeftPanel = ({ showLeftPanel = false }: { showLeftPanel?: boolean }) => {
  const { hasPermission } = useAuth();
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate("/dashboard");
  };

  const getHightlightBar = () => {
    const pathSegment = window.location.pathname.split("/academy")[1]?.split('/')[1];
    const highlightPaths = [LIBRARY_ROUTES.VIEW_COURSE_TEMPLATES, LIBRARY_ROUTES.CREATE_COURSE, LIBRARY_ROUTES.COPY_COURSE, LIBRARY_ROUTES.EDIT_COURSE, LIBRARY_ROUTES.VIEW_COURSE, LIBRARY_ROUTES.START_COURSE_INSTANCE, LIBRARY_ROUTES.EDIT_COURSE_INSTANCE, LIBRARY_ROUTES.VIEW_DEPLOYED_COURSE_INSTANCE];

    return highlightPaths.includes(pathSegment) ? "highlight-bar" : "";
  }

  const getLibraryPath = () => {
    const pathSegment = window.location.pathname.split("/academy")[1]?.split('/')[1];
    const highlightPaths = [LIBRARY_ROUTES.VIEW_COURSE_TEMPLATES, LIBRARY_ROUTES.CREATE_COURSE, LIBRARY_ROUTES.COPY_COURSE, LIBRARY_ROUTES.EDIT_COURSE, LIBRARY_ROUTES.START_COURSE_INSTANCE, LIBRARY_ROUTES.EDIT_COURSE_INSTANCE];
    return `/${highlightPaths.includes(pathSegment) ? window.location.pathname.split("/academy/")[1] : LIBRARY_ROUTES.VIEW_COURSE_TEMPLATES}`;
  }

  const optionListAdded = () => {
    let optionList = [];

    if (hasPermission(PermissionConstant.COURSE_LIBRARY_VIEW)) {
      optionList.push(
        {
          label: "Library Management",
          path: getLibraryPath(),
          prefix: (
            <img
              src="/library-management-icon.svg"
              alt=""
              className={`mt-1.5 ${btnResponsive("panel-icons")}`}
            />
          ),
        });
    }
    if (hasPermission(PermissionConstant.ISO_FILE_MANAGEMENT_VIEW)) {
      optionList.push({
        label: "ISO File Management",
        path: "/iso-file-management",
        prefix: (
          <img
            src="/iso-file-management.svg"
            alt=""
            className={`mt-1.5 ${btnResponsive("panel-icons")}`}
          />
        ),
      });
    }
    if (hasPermission(PermissionConstant.FILE_MANAGEMENT_VIEW)) {
      optionList.push({
        label: "File Management",
        path: "/file-management",
        prefix: (
          <img
            src="/iso-icon.svg"
            alt=""
            className={`mt-1.5 ${btnResponsive("panel-icons")}`}
          />
        ),
      });
    }

    return optionList;
  };

  return (
    <div
      className="text-white pt-6 menu-Item h-[100vh] relative"
      style={{ "--panel-bg-color": "WHITE" } as React.CSSProperties}
    >
      <p className={`absolute ${getHightlightBar()}`}></p>
      <Menu
        onClick={function noRefCheck(e) {
          navigate("/academy" + e);
        }}
        className=""
        variant={`${showLeftPanel ? "default" : "collapsable"}`}
        config={[
          {
            items: [
              {
                label: "COURSE ADMIN",
                itemType: "item",
                external: true,
                prefix: (
                  <img
                    src="/icon.png"
                    alt="H"
                    className={`${showLeftPanel ? "mr-0.5" : null} w-[22px] h-[22px] xl-mid:w-[25px] xl-mid:h-[25px] xl-high:w-[32px] xl-high:h-[32px]`}
                  />
                ),
              },
            ],
            className: "",
          },
          {
            items: optionListAdded(),
          },
        ]}
      />
      {showLeftPanel ? (
        <div className="absolute bottom-0 left-0 w-full py-4 px-2 bg-transparent border-t text-white">
          <div
            id="navigate-home"
            data-testid="navigate-home"
            className="flex space-x-2 text-sm footer-home items-center justify-center cursor-pointer"
            onClick={handleNavigateHome}
          >
            <HomeIcon
              className={`text-white ${btnResponsive("panel-icons")}`}
            />
            <p className={`${textResponsive("text-sm")}`}>DIGITAL PRIME TWIN</p>
          </div>
        </div>
      ) : (
        <div className="absolute bottom-0 left-0 w-full mb-1 py-4 px-2 bg-transparent border-t text-white">
          <div
            id="navigate-home"
            data-testid="navigate-home"
            className="flex space-x-2 text-sm footer-home items-center justify-center cursor-pointer"
            onClick={handleNavigateHome}
          >
            <HomeIcon className={`text-white ${btnResponsive("panel-icons")}`} />
          </div>
        </div>
      )}
    </div>
  );
};
export default LeftPanel;
